/* ============================================================
   Wear Black Camels — Theme JS
   Header scroll behavior, nav drawer, submenu toggle,
   accordion, read more/less, color swatches
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Header logo visibility (no scroll behavior) ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    /* Enforce desktop logo visibility — header is always solid (white bg),
       so always show the dark logo. Mobile logo is NOT touched. */
    function enforceDesktopLogo() {
      var desktopInner = header.querySelector('.site-header__inner--desktop');
      if (!desktopInner) return;

      var lightImg = desktopInner.querySelector('.site-header__logo-img--light');
      var darkImg = desktopInner.querySelector('.site-header__logo-img--dark');

      if (lightImg) {
        lightImg.style.setProperty('display', 'none', 'important');
      }
      if (darkImg) {
        darkImg.style.setProperty('display', 'inline-block', 'important');
      }
    }

    /* Header is in normal document flow — no scroll listener needed.
       Just enforce logo visibility once on load. */
    enforceDesktopLogo();
  }

  /* ---------- Nav drawer (open/close) ---------- */
  function initDrawer() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    if (!toggle || !drawer || !overlay) return;

    var closeBtns = drawer.querySelectorAll('[data-drawer-close]');

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-active');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    overlay.addEventListener('click', close);
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Drawer submenu toggle ---------- */
  function initSubmenuToggle() {
    var toggles = document.querySelectorAll('[data-submenu-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var sublist = btn.nextElementSibling;
        btn.setAttribute('aria-expanded', !expanded);
        if (sublist) {
          sublist.hidden = expanded;
        }
      });
    });
  }

  /* ---------- Accordion (home-accordions) ---------- */
  function initAccordions() {
    var items = document.querySelectorAll('.home-accordions__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        // Close all other items
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var otherTrigger = other.querySelector('[data-accordion-trigger]');
            var otherContent = other.querySelector('[data-accordion-content]');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherContent) otherContent.setAttribute('aria-hidden', 'true');
          }
        });
        // Toggle current
        if (isOpen) {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          var content = item.querySelector('[data-accordion-content]');
          if (content) content.setAttribute('aria-hidden', 'true');
        } else {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          var content2 = item.querySelector('[data-accordion-content]');
          if (content2) content2.setAttribute('aria-hidden', 'false');
          // Check read more when opening
          checkReadMore(item);
        }
      });
    });
  }

  /* ---------- Read more / read less (4-line clamp) ---------- */
  function checkReadMore(item) {
    var text = item.querySelector('[data-accordion-text]');
    var button = item.querySelector('[data-read-more]');
    if (!text || !button) return;

    // Remove previous state
    text.classList.remove('is-clamped');
    button.classList.remove('has-more');
    button.classList.remove('is-expanded');
    button.setAttribute('aria-expanded', 'false');

    var computedStyle = window.getComputedStyle(text);
    var lineHeight = parseFloat(computedStyle.lineHeight);
    if (!lineHeight || isNaN(lineHeight)) {
      lineHeight = parseFloat(computedStyle.fontSize) * 1.55;
    }
    var fourLineHeight = lineHeight * 4;
    var fullHeight = text.scrollHeight;

    if (fullHeight > fourLineHeight + 2) {
      text.classList.add('is-clamped');
      button.classList.add('has-more');
    }
  }

  function initReadMore() {
    var buttons = document.querySelectorAll('[data-read-more]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = button.closest('.home-accordions__item');
        if (!item) return;
        var text = item.querySelector('[data-accordion-text]');
        if (!text) return;

        var expanded = button.classList.contains('is-expanded');
        if (expanded) {
          text.classList.add('is-clamped');
          button.classList.remove('is-expanded');
          button.setAttribute('aria-expanded', 'false');
        } else {
          text.classList.remove('is-clamped');
          button.classList.add('is-expanded');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- About us read more / less (legacy) ---------- */
  function initAboutToggle() {
    var text = document.querySelector('[data-story-text]');
    var toggle = document.querySelector('[data-story-toggle]');
    if (!text || !toggle) return;

    var paragraphs = text.querySelectorAll('.about-us__story-paragraph');
    if (paragraphs.length <= 2) { toggle.hidden = true; return; }

    toggle.hidden = false;
    text.classList.add('is-collapsed');
    toggle.setAttribute('data-state', 'more');

    toggle.addEventListener('click', function () {
      var collapsed = text.classList.toggle('is-collapsed');
      toggle.setAttribute('data-state', collapsed ? 'more' : 'less');
    });
  }

  /* ---------- Color swatch helper ---------- */
  function initSwatches() {
    var swatches = document.querySelectorAll('[data-color-swatches]');
    if (!swatches.length) return;

    var colorMap = {
      'mauve': '#c77b8c',
      'coffee': '#4b2e25',
      'ivory-cream': '#f3ecd9',
      'ivory': '#f3ecd9',
      'cream': '#f3ecd9',
      'brown': '#5a3a22',
      'black': '#000000',
      'white': '#ffffff',
      'navy': '#1f2a44',
      'grey': '#8a8a8a',
      'gray': '#8a8a8a',
      'beige': '#d9c7a8',
      'olive': '#5b5a2b',
      'green': '#2f5d3a',
      'red': '#8b1f1f',
      'blue': '#2a4a7c',
      'pink': '#e3a9b6',
      'maroon': '#5a1f1f',
      'charcoal': '#333333',
      'sand': '#cdbb97',
      'khaki': '#9b8b62',
      'wine': '#5a1f2f',
      'mustard': '#c9a227',
      'rust': '#8b3a1f',
      'teal': '#1f5d5a',
      'purple': '#5a2a6b',
      'lavender': '#b8a8d9',
      'peach': '#e3b88f',
      'coral': '#e37b6b',
      'mint': '#9bd9b8',
      'sky': '#a8c8e3'
    };

    swatches.forEach(function (list) {
      list.querySelectorAll('[data-swatch-name]').forEach(function (sw) {
        var name = sw.getAttribute('data-swatch-name');
        if (colorMap[name]) {
          sw.style.backgroundColor = colorMap[name];
        }
      });
    });
  }

  /* ---------- Features carousel (mobile) ---------- */
  function initFeaturesCarousel() {
    var slider = document.querySelector('.home-features__slider');
    if (!slider) return;
    var prev = document.querySelector('[data-features-prev]');
    var next = document.querySelector('[data-features-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        slider.scrollBy({ left: -slider.offsetWidth * 0.55, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        slider.scrollBy({ left: slider.offsetWidth * 0.55, behavior: 'smooth' });
      });
    }
  }

  /* ---------- Products carousel (mobile) ---------- */
  function initProductsCarousel() {
    var grids = document.querySelectorAll('.home-products__grid');
    grids.forEach(function (grid) {
      var prev = grid.parentElement.querySelector('[data-products-prev]');
      var next = grid.parentElement.querySelector('[data-products-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          grid.scrollBy({ left: -grid.offsetWidth, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          grid.scrollBy({ left: grid.offsetWidth, behavior: 'smooth' });
        });
      }
    });
  }

  /* ---------- Re-check read more on resize/fonts ---------- */
  function initReadMoreResizeCheck() {
    var items = document.querySelectorAll('.home-accordions__item');
    if (!items.length) return;

    function checkAll() {
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) {
          checkReadMore(item);
        }
      });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(checkAll);
    } else {
      setTimeout(checkAll, 100);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkAll, 150);
    });
  }

  /* ---------- Cart Drawer ---------- */
  var cartDrawer, cartOverlay, cartToggleBtn, cartCloseBtn;
  var cartItemsContainer, cartEmptyEl, cartFooter, cartSubtotalEl, cartCountEls;
  var cartUpsellEl, upsellSlider, upsellDotsContainer, upsellPrevBtn, upsellNextBtn;
  var _upsellRequestId = 0;
  var _upsellArrowBound = false;

  function initCartDrawer() {
    cartDrawer = document.querySelector('[data-cart-drawer]');
    cartOverlay = document.querySelector('[data-drawer-overlay]');
    cartToggleBtn = document.querySelector('[data-cart-toggle]');
    if (!cartDrawer) return;

    cartCloseBtn = cartDrawer.querySelector('[data-cart-drawer-close]');
    cartItemsContainer = cartDrawer.querySelector('[data-cart-items]');
    cartEmptyEl = cartDrawer.querySelector('[data-cart-empty]');
    cartFooter = cartDrawer.querySelector('[data-cart-footer]');
    cartSubtotalEl = cartDrawer.querySelector('[data-cart-subtotal]');
    cartCountEls = document.querySelectorAll('[data-cart-count]');
    cartUpsellEl = cartDrawer.querySelector('[data-cart-upsell]');
    upsellSlider = cartDrawer.querySelector('[data-upsell-slider]');
    upsellDotsContainer = cartDrawer.querySelector('[data-upsell-dots]');
    upsellPrevBtn = cartDrawer.querySelector('[data-upsell-prev]');
    upsellNextBtn = cartDrawer.querySelector('[data-upsell-next]');

    // Attach click handler to ALL cart toggle buttons (mobile + desktop)
    var allCartToggles = document.querySelectorAll('[data-cart-toggle]');
    allCartToggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });
    if (cartCloseBtn) {
      cartCloseBtn.addEventListener('click', closeCartDrawer);
    }
    if (cartOverlay) {
      cartOverlay.addEventListener('click', closeCartDrawer);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    });

    // Delegate events for qty + remove buttons
    if (cartItemsContainer) {
      cartItemsContainer.addEventListener('click', function (e) {
        var qtyBtn = e.target.closest('[data-cart-qty-change]');
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (qtyBtn) {
          var key = qtyBtn.getAttribute('data-key');
          var dir = qtyBtn.getAttribute('data-cart-qty-change');
          var input = cartItemsContainer.querySelector('[data-cart-qty-input="' + key + '"]');
          var currentQty = parseInt(input.value, 10) || 1;
          var newQty = dir === 'plus' ? currentQty + 1 : currentQty - 1;
          if (newQty < 1) newQty = 1;
          changeCartItem(key, newQty);
        }
        if (removeBtn) {
          var rKey = removeBtn.getAttribute('data-key');
          changeCartItem(rKey, 0);
        }
      });
    }
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    fetchCart();
    // Poll cart a few times to catch add-on apps (e.g. Selleasy)
    // that add items shortly after the drawer opens
    clearInterval(window._wbcCartPoll);
    var pollCount = 0;
    window._wbcCartPoll = setInterval(function () {
      if (!cartDrawer.classList.contains('is-open') || pollCount >= 3) {
        clearInterval(window._wbcCartPoll);
        return;
      }
      pollCount++;
      fetchCart();
    }, 2000);
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
    clearInterval(window._wbcCartPoll);
  }

  function formatMoney(cents) {
    var symbol = (window.theme && window.theme.currencySymbol) ? window.theme.currencySymbol : '$';
    var format = symbol + '{{amount}}';
    if (window.theme && window.theme.moneyFormat) {
      format = window.theme.moneyFormat;
    }
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    return symbol + (cents / 100).toFixed(2);
  }

  var _lastCartSignature = '';

  function fetchCart() {
    fetch(window.routes.cart_url + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  function renderCart(cart) {
    // Skip re-render if cart hasn't changed (prevents DOM-mutation loops with 3rd-party apps)
    var signature = cart.item_count + '|' + cart.total_price + '|' + cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join(',');
    if (signature === _lastCartSignature) return;
    _lastCartSignature = signature;

    // Update count
    var count = cart.item_count;
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'flex';
    });

    // Update subtotal
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);

    // Update free shipping progress bar
    var shippingFill = cartDrawer.querySelector('[data-cart-shipping-fill]');
    var shippingMsg = cartDrawer.querySelector('[data-cart-shipping-msg]');
    var FREE_SHIPPING_THRESHOLD = 10000; // $100 in cents
    var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
    var pct = Math.min((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100, 100);
    if (shippingFill) shippingFill.style.width = pct + '%';
    if (shippingMsg) {
      if (cart.total_price >= FREE_SHIPPING_THRESHOLD) {
        shippingMsg.textContent = 'Your order qualifies for FREE US shipping';
      } else {
        shippingMsg.textContent = 'Add ' + formatMoney(remaining) + ' more for FREE US shipping';
      }
    }

    // Render items
    if (count === 0) {
      if (cartEmptyEl) cartEmptyEl.style.display = 'block';
      if (cartItemsContainer) {
        cartItemsContainer.innerHTML = '';
        cartItemsContainer.hidden = true;
      }
      if (cartFooter) cartFooter.hidden = true;
      if (cartUpsellEl) cartUpsellEl.hidden = true;
      return;
    }

    if (cartEmptyEl) cartEmptyEl.style.display = 'none';
    if (cartItemsContainer) cartItemsContainer.hidden = false;
    if (cartFooter) cartFooter.hidden = false;

    var html = cart.items.map(function (item) {
      var img = item.image ? item.image.replace('.jpg', '_140x.jpg').replace('.png', '_140x.png').replace('.webp', '_140x.webp') : '';
      var variantTitle = item.variant_title ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '';
      var priceLine = '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>';
      return '<div class="cart-drawer__item" data-cart-item-key="' + item.key + '">' +
        '<div class="cart-drawer__item-image">' +
        (img ? '<img src="' + img + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '">' : '') +
        '</div>' +
        '<div class="cart-drawer__item-details">' +
        '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
        variantTitle +
        priceLine +
        '<p class="cart-drawer__item-stock">In stock</p>' +
        '<div class="cart-drawer__item-bottom">' +
        '<div class="cart-drawer__item-qty">' +
        '<button type="button" class="cart-drawer__item-qty-btn" data-cart-qty-change="minus" data-key="' + item.key + '">&minus;</button>' +
        '<input type="number" class="cart-drawer__item-qty-input" data-cart-qty-input="' + item.key + '" value="' + item.quantity + '" min="1" readonly>' +
        '<button type="button" class="cart-drawer__item-qty-btn" data-cart-qty-change="plus" data-key="' + item.key + '">+</button>' +
        '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '" aria-label="Remove item">Remove</button>' +
        '</div>' +
        '</div>';
    }).join('');

    if (cartItemsContainer) cartItemsContainer.innerHTML = html;

    // Trigger upsell recommendations
    fetchUpsellRecommendations(cart);
  }

  /* ---------- Cart Drawer — Upsell Recommendations ---------- */
  function isAbayaProduct(p) {
    // Check tags for Abaya-related tags
    if (p.tags) {
      var tags = typeof p.tags === 'string' ? p.tags.split(',') : p.tags;
      for (var i = 0; i < tags.length; i++) {
        if (/abaya/i.test(tags[i].trim())) return true;
      }
    }
    // Check product type
    if (p.type && /abaya/i.test(p.type)) return true;
    // Check title
    if (p.title && /abaya/i.test(p.title)) return true;
    return false;
  }

  function fetchUpsellRecommendations(cart) {
    if (!cartUpsellEl || !upsellSlider) return;
    var reqId = ++_upsellRequestId;

    // Get product IDs in cart to exclude them from recommendations
    var cartProductIds = cart.items.map(function (item) { return item.product_id; });

    // Use the last added product for recommendations
    var lastProduct = cart.items[cart.items.length - 1];
    if (!lastProduct || !lastProduct.product_id) {
      cartUpsellEl.hidden = true;
      return;
    }

    var productId = lastProduct.product_id;
    var recUrl = '/recommendations/products.json?product_id=' + productId + '&limit=20';

    fetch(recUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (reqId !== _upsellRequestId) return; // stale response
        var products = (data && data.products) ? data.products : [];
        // Filter out products already in cart
        products = products.filter(function (p) {
          return cartProductIds.indexOf(p.id) === -1;
        });
        // Filter to ONLY Abaya products
        products = products.filter(function (p) { return isAbayaProduct(p); });
        // Take up to 5
        products = products.slice(0, 5);

        if (products.length === 0) {
          cartUpsellEl.hidden = true;
          return;
        }

        renderUpsellProducts(products);
        cartUpsellEl.hidden = false;
      })
      .catch(function () {
        if (reqId === _upsellRequestId) cartUpsellEl.hidden = true;
      });
  }

  function renderUpsellProducts(products) {
    if (!upsellSlider || !upsellDotsContainer) return;

    var html = products.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img) {
        if (img.indexOf('//') === 0) img = 'https:' + img;
        img = img.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png').replace('.webp', '_300x.webp');
      }
      var price = p.price ? formatMoney(p.price) : '';

      // Build color swatches from variants
      var swatches = '';
      if (p.variants && p.variants.length > 0) {
        var colorOptionIndex = -1;
        if (p.options) {
          for (var i = 0; i < p.options.length; i++) {
            var optName = (typeof p.options[i] === 'string') ? p.options[i] : (p.options[i] && p.options[i].name ? p.options[i].name : '');
            if (/color|colour/i.test(optName)) { colorOptionIndex = i; break; }
          }
        }
        if (colorOptionIndex >= 0) {
          var seenColors = {};
          var swatchItems = [];
          p.variants.forEach(function (v) {
            if (v.options && v.options[colorOptionIndex]) {
              var colorName = v.options[colorOptionIndex];
              if (!seenColors[colorName]) {
                seenColors[colorName] = true;
                swatchItems.push('<span class="cart-drawer__upsell-swatch" title="' + colorName.replace(/"/g, '"') + '" style="background:' + colorNameToCss(colorName) + '"></span>');
              }
            }
          });
          if (swatchItems.length > 0) {
            swatches = '<div class="cart-drawer__upsell-card-swatches">' + swatchItems.join('') + '</div>';
          }
        }
      }

      return '<a href="' + p.url + '" class="cart-drawer__upsell-card">' +
        '<div class="cart-drawer__upsell-card-image">' +
        (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '"') + '" loading="lazy" draggable="false">' : '') +
        '</div>' +
        '<div class="cart-drawer__upsell-card-info">' +
        '<p class="cart-drawer__upsell-card-title">' + p.title + '</p>' +
        '<p class="cart-drawer__upsell-card-price">' + price + '</p>' +
        swatches +
        '</div>' +
        '</a>';
    }).join('');

    upsellSlider.innerHTML = html;
    upsellSlider.scrollLeft = 0;

    if (!upsellPrevBtn || !upsellNextBtn) return;
    if (!_upsellArrowBound) {
      _upsellArrowBound = true;
      upsellPrevBtn.addEventListener('click', function () {
        if (!upsellSlider || !upsellSlider.querySelector('.cart-drawer__upsell-card')) return;
        var cardWidth = upsellSlider.querySelector('.cart-drawer__upsell-card').offsetWidth || 220;
        upsellSlider.scrollBy({ left: -cardWidth - 16, behavior: 'smooth' });
      });
      upsellNextBtn.addEventListener('click', function () {
        if (!upsellSlider || !upsellSlider.querySelector('.cart-drawer__upsell-card')) return;
        var cardWidth = upsellSlider.querySelector('.cart-drawer__upsell-card').offsetWidth || 220;
        upsellSlider.scrollBy({ left: cardWidth + 16, behavior: 'smooth' });
      });
    }

    // Build dots
    buildUpsellDots(products.length);
  }

  function colorNameToCss(name) {
    var map = {
      'black': '#000', 'white': '#fff', 'cream': '#f5f0e6', 'ivory': '#fffff0',
      'navy': '#1a2b4a', 'navy blue': '#1a2b4a', 'ice blue': '#ace8f4',
      'blue': '#3b82f6', 'brown': '#8b4513', 'sage': '#b7c4a0', 'green': '#4caf50',
      'pink': '#f8c4d4', 'soft pink': '#f8c4d4', 'grey': '#9ca3af', 'gray': '#9ca3af',
      'red': '#ef4444', 'mauve': '#e0b0d0', 'coffee': '#6f4e37', 'gold': '#d4af37',
      'silver': '#c0c0c0', 'beige': '#e8d8c4', 'khaki': '#c3b091', 'olive': '#808000',
      'purple': '#9c27b0', 'orange': '#ff9800', 'yellow': '#ffeb3b', 'burgundy': '#800020',
      'deep wine': '#722f37', 'wine': '#722f37', 'midnight blue': '#191970',
      'ice': '#d6f0ff', 'midnight': '#191970', 'rose': '#ff007f',
      'tan': '#d2b48c', 'sand': '#c2b280', 'charcoal': '#36454f',
      'multi': '#linear-gradient(135deg,#ff6b6b,#4ecdc4,#45b7d1)', 'floral': '#e8d8c4'
    };
    var key = name.toLowerCase().trim();
    return map[key] || '#ccc';
  }

  var _upsellScrollBound = false;
  var _upsellDragBound = false;

  function buildUpsellDots(totalItems) {
    if (!upsellDotsContainer || !upsellSlider) return;
    upsellDotsContainer.innerHTML = '';

    // One dot per product (not per page)
    for (var i = 0; i < totalItems; i++) {
      (function (idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cart-drawer__upsell-dot' + (idx === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to product ' + (idx + 1));
        dot.addEventListener('click', function () {
          var cards = upsellSlider.querySelectorAll('.cart-drawer__upsell-card');
          if (cards.length === 0) return;
          var cardWidth = cards[0].offsetWidth;
          upsellSlider.scrollTo({ left: idx * cardWidth, behavior: 'smooth' });
        });
        upsellDotsContainer.appendChild(dot);
      })(i);
    }

    // Bind scroll listener only once
    if (_upsellScrollBound) return;
    _upsellScrollBound = true;

    var scrollTimer;
    upsellSlider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var cards = upsellSlider.querySelectorAll('.cart-drawer__upsell-card');
        if (cards.length === 0) return;
        var cardWidth = cards[0].offsetWidth;
        if (cardWidth <= 0) return;
        var idx = Math.round(upsellSlider.scrollLeft / cardWidth);
        var dots = upsellDotsContainer.querySelectorAll('.cart-drawer__upsell-dot');
        idx = Math.max(0, Math.min(idx, dots.length - 1));
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, 80);
    }, { passive: true });

    // Pointer-based drag support (desktop + mobile) — bind once
    if (_upsellDragBound) return;
    _upsellDragBound = true;

    var isDown = false;
    var startX = 0;
    var scrollStart = 0;
    var hasDragged = false;

    function snapToNearest() {
      var cards = upsellSlider.querySelectorAll('.cart-drawer__upsell-card');
      if (cards.length === 0) return;
      var cardWidth = cards[0].offsetWidth;
      if (cardWidth <= 0) return;
      var idx = Math.round(upsellSlider.scrollLeft / cardWidth);
      idx = Math.max(0, Math.min(idx, cards.length - 1));
      upsellSlider.scrollTo({ left: idx * cardWidth, behavior: 'smooth' });
    }

    // Pointer events — work for both mouse (desktop) and touch (mobile)
    upsellSlider.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDown = true;
      hasDragged = false;
      startX = e.clientX;
      scrollStart = upsellSlider.scrollLeft;
      upsellSlider.classList.add('is-dragging');
    });

    document.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var walk = e.clientX - startX;
      if (Math.abs(walk) > 5) hasDragged = true;
      upsellSlider.scrollLeft = scrollStart - walk;
    });

    document.addEventListener('pointerup', function () {
      if (!isDown) return;
      isDown = false;
      upsellSlider.classList.remove('is-dragging');
      snapToNearest();
    });

    document.addEventListener('pointercancel', function () {
      if (!isDown) return;
      isDown = false;
      upsellSlider.classList.remove('is-dragging');
      snapToNearest();
    });

    // Touch fallback — ensures mobile swipe works even if pointer events don't fire
    var tStartX = 0;
    var tScrollStart = 0;
    var tActive = false;

    upsellSlider.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tActive = true;
      tStartX = e.touches[0].clientX;
      tScrollStart = upsellSlider.scrollLeft;
    }, { passive: true });

    upsellSlider.addEventListener('touchmove', function (e) {
      if (!tActive || e.touches.length !== 1) return;
      var walk = e.touches[0].clientX - tStartX;
      upsellSlider.scrollLeft = tScrollStart - walk;
    }, { passive: true });

    upsellSlider.addEventListener('touchend', function () {
      if (!tActive) return;
      tActive = false;
      snapToNearest();
    }, { passive: true });

    // Prevent click navigation after drag
    upsellSlider.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);
  }

  function changeCartItem(key, quantity) {
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  /* ---------- Coming Soon products — cart block ---------- */
  var WBC_COMING_SOON_HANDLES = ['contrast-active-set-black', 'active-set-black'];
  var comingSoonVariantIds = [];

  function loadComingSoonVariants() {
    WBC_COMING_SOON_HANDLES.forEach(function (handle) {
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          if (product && product.variants) {
            product.variants.forEach(function (v) {
              if (comingSoonVariantIds.indexOf(v.id) === -1) comingSoonVariantIds.push(v.id);
            });
          }
        })
        .catch(function () {});
    });
  }

  function isComingSoonVariant(variantId) {
    if (!variantId) return false;
    return comingSoonVariantIds.indexOf(parseInt(variantId, 10)) !== -1;
  }

  function isPreOrderVariant(variantId) {
    if (!variantId) return false;
    if (!window.WBC_PREORDER_VARIANT_IDS) return false;
    return window.WBC_PREORDER_VARIANT_IDS.indexOf(parseInt(variantId, 10)) !== -1;
  }

  // Intercept fetch calls to /cart/add — blocks coming-soon and pre-order products
  var _originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
    if (urlStr.indexOf('/cart/add') !== -1) {
      var opts = arguments[1] || {};
      var body = opts.body;
      if (body instanceof FormData) {
        var vid = body.get('id');
        if (isComingSoonVariant(vid)) {
          return Promise.reject(new Error('This product is Coming Soon and cannot be purchased.'));
        }
        if (isPreOrderVariant(vid)) {
          return Promise.reject(new Error('This product is on Pre Order and cannot be purchased yet.'));
        }
      }
      if (typeof body === 'string') {
        try {
          var parsed = JSON.parse(body);
          if (parsed && isComingSoonVariant(parsed.id)) {
            return Promise.reject(new Error('This product is Coming Soon and cannot be purchased.'));
          }
          if (parsed && isPreOrderVariant(parsed.id)) {
            return Promise.reject(new Error('This product is on Pre Order and cannot be purchased yet.'));
          }
        } catch (e) {}
      }
    }
    return _originalFetch.apply(this, arguments);
  };

  // Public API for ATC to call
  window.WBCCart = {
    open: openCartDrawer,
    close: closeCartDrawer,
    fetch: fetchCart,
    render: renderCart,
    add: function (formData, onSuccess, onError) {
      // Coming Soon guard — check variant ID before any network request
      var vid = formData instanceof FormData ? formData.get('id') : null;
      if (isComingSoonVariant(vid)) {
        if (onError) onError(new Error('This product is Coming Soon and cannot be purchased.'));
        return;
      }
      // Pre Order guard — check variant ID before any network request
      if (isPreOrderVariant(vid)) {
        if (onError) onError(new Error('This product is on Pre Order and cannot be purchased yet.'));
        return;
      }
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          openCartDrawer();
          if (onSuccess) onSuccess(item);
        })
        .catch(function (err) {
          if (onError) onError(err);
        });
    }
  };

  /* ---------- Prevent double-tap-to-zoom (mobile) ----------
     Meta viewport (user-scalable=no) is not enough on all mobile browsers
     (iOS Safari in particular still allows double-tap zoom). This blocks
     the fast double-tap gesture everywhere EXCEPT inside the product
     image lightbox, where pinch/zoom should remain available. */
  function initDoubleTapZoomLock() {
    var lastTouchEnd = 0;
    document.addEventListener('touchend', function (e) {
      if (e.target.closest && e.target.closest('[data-product-lightbox]')) {
        return; // allow zoom inside the image lightbox
      }
      var now = Date.now();
      if (now - lastTouchEnd <= 350) {
        e.preventDefault();
      }
      lastTouchEnd = now;
    }, { passive: false });
  }

  /* ---------- Buy Now — add to cart and redirect to checkout ---------- */
  function initBuyNow() {
    var buyNowBtn = document.querySelector('[data-buy-now]');
    if (!buyNowBtn) return;
    // Pre Order guard — block Buy Now entirely for pre-order products
    if (buyNowBtn.disabled) return;
    buyNowBtn.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (!form) return;
      // Pre Order guard — do not proceed if product is pre-order
      if (form.getAttribute('data-pre-order') === 'true') return;
      var variantInput = form.querySelector('[data-variant-id]');
      var qtyInput = form.querySelector('[data-qty-input]');
      if (!variantInput) return;
      var variantId = variantInput.value;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      buyNowBtn.disabled = true;
      buyNowBtn.querySelector('span').textContent = 'Processing...';
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () {
          buyNowBtn.disabled = false;
          buyNowBtn.querySelector('span').textContent = 'Buy Now';
        });
    });
    // Reset Buy Now button when user returns via browser back (bfcache)
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        buyNowBtn.disabled = false;
        var span = buyNowBtn.querySelector('span');
        if (span) span.textContent = 'Buy Now';
      }
    });
  }

  /* ---------- Quick View + Quick Add (Collection Page only) ---------- */
  function initQuickView() {
    var modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) return;
    var body = modal.querySelector('[data-qv-body]');
    var productCache = {};

    function open(handle) {
      if (!handle) {
        body.innerHTML = '<div class="qv-modal__loading">Error: No product specified.</div>';
        return;
      }
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      body.innerHTML = '<div class="qv-modal__loading">Loading...</div>';
      document.body.style.overflow = 'hidden';
      fetchProduct(handle).then(function (product) {
        try {
          renderQuickView(product);
        } catch (renderErr) {
          console.error('[QuickView] Render error:', renderErr);
          body.innerHTML = '<div class="qv-modal__loading">Error displaying product: ' + (renderErr && renderErr.message ? renderErr.message : 'Unknown error') + '</div>';
        }
      }).catch(function (fetchErr) {
        console.error('[QuickView] Fetch error:', fetchErr);
        body.innerHTML = '<div class="qv-modal__loading">Error loading product. Check console.</div>';
      });
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function fetchProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          productCache[handle] = product;
          return product;
        });
    }

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function getImageUrl(src, size) {
      if (!src) return '';
      // Shopify CDN URLs: https://cdn.shopify.com/s/files/.../image.jpg?v=123
      // Insert _{size} before the file extension
      return src.replace(/\.(jpg|jpeg|png|gif|webp)/i, function (match) {
        return '_' + size + match;
      });
    }

    function renderQuickView(product) {
      var images = product.images || [];
      if (images.length === 0) images = [''];

      /* --- LEFT: Main image + thumbnail slider with arrows --- */
      var mainImg = getImageUrl(images[0], '500x');
      var thumbsHtml = images.map(function (img, i) {
        return '<div class="qv-inner__thumb' + (i === 0 ? ' is-active' : '') + '" data-qv-thumb="' + i + '">' +
          '<img src="' + getImageUrl(img, '80x') + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' +
        '</div>';
      }).join('');

      var showArrows = images.length > 1;

      /* --- RIGHT: Product info — reuses Single Product Page CSS classes --- */

      // Find option indices — Shopify product.js returns options as array of strings
      var sizeOptionIndex = -1;
      var colorOptionIndex = -1;
      (product.options || []).forEach(function (opt, i) {
        var optStr = typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : String(opt || ''));
        var lower = optStr.toLowerCase();
        if (lower === 'size') sizeOptionIndex = i;
        else if (lower === 'color' || lower === 'colour') colorOptionIndex = i;
      });

      // Build color display — EXACTLY like Single Product Page (swatches, display only)
      var colorDisplay = '';
      if (colorOptionIndex !== -1) {
        var colorValues = [];
        (product.variants || []).forEach(function (v) {
          var val = v.options[colorOptionIndex];
          if (colorValues.indexOf(val) === -1) colorValues.push(val);
        });
        var firstColor = colorValues[0] || '';
        var swatchesHtml = colorValues.map(function (color, idx) {
          var colorStr = typeof color === 'string' ? color : String(color || '');
          var colorHandle = colorStr.toLowerCase().replace(/ /g, '-');
          var hex = (window.WBCColorMap && window.WBCColorMap[colorHandle]) ? window.WBCColorMap[colorHandle] : '#ccc';
          return '<input type="radio" name="qv-color" value="' + colorStr.replace(/"/g, '&quot;') + '" id="qv-color-' + idx + '" class="sr-only"' + (idx === 0 ? ' checked' : '') + ' disabled>' +
            '<label for="qv-color-' + idx + '" class="product-info__swatch" style="--hdt-bg-color: ' + hex + ';" title="' + colorStr.replace(/"/g, '&quot;') + '">' +
            '<span class="sr-only">' + colorStr + '</span></label>';
        }).join('');
        colorDisplay =
          '<fieldset class="product-info__option product-info__option--color">' +
            '<legend class="product-info__option-label">Color: <span data-qv-color-label>' + firstColor + '</span></legend>' +
            '<div class="product-info__option-values">' + swatchesHtml + '</div>' +
          '</fieldset>';
      }

      // Auto-select the first available color
      var autoColor = null;
      if (colorOptionIndex !== -1) {
        var variants = product.variants || [];
        var firstAvailVariant = variants.find(function (v) { return v.available; });
        if (firstAvailVariant) {
          autoColor = firstAvailVariant.options[colorOptionIndex];
        } else if (variants[0] && variants[0].options) {
          autoColor = variants[0].options[colorOptionIndex];
        }
      }

      // Build size buttons — uses product-info__size-pill class
      // Only show sizes available for the auto-selected color
      var sizesHtml = '';
      if (sizeOptionIndex !== -1) {
        var sizeValues = [];
        (product.variants || []).forEach(function (v) {
          // If color exists, only show sizes for the auto-selected color
          if (colorOptionIndex !== -1 && autoColor !== null) {
            if (v.options[colorOptionIndex] !== autoColor) return;
          }
          var val = v.options[sizeOptionIndex];
          if (sizeValues.indexOf(val) === -1) sizeValues.push(val);
        });
        sizesHtml = sizeValues.map(function (size, idx) {
          var hasAvail = (product.variants || []).some(function (v) {
            return v.options[sizeOptionIndex] === size && v.available &&
                   (colorOptionIndex === -1 || autoColor === null || v.options[colorOptionIndex] === autoColor);
          });
          var sizeStr = typeof size === 'string' ? size : String(size || '');
          return '<input type="radio" name="qv-size" value="' + sizeStr.replace(/"/g, '&quot;') + '" id="qv-size-' + idx + '" class="sr-only" data-qv-size="' + sizeStr.replace(/"/g, '&quot;') + '"' + (hasAvail ? '' : ' disabled') + '>' +
            '<label for="qv-size-' + idx + '" class="product-info__size-pill' + (hasAvail ? '' : ' is-disabled') + '">' + sizeStr + '</label>';
        }).join('');
      } else if (product.variants && product.variants.length > 1) {
        sizesHtml = product.variants.map(function (v, idx) {
          return '<input type="radio" name="qv-size" value="' + v.id + '" id="qv-size-' + idx + '" class="sr-only" data-qv-size="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
            '<label for="qv-size-' + idx + '" class="product-info__size-pill' + (v.available ? '' : ' is-disabled') + '">' + (v.title || '') + '</label>';
        }).join('');
      }

      // Price — uses product-info__price classes
      var priceHtml = '';
      if (product.compare_at_price > product.price) {
        priceHtml = '<span class="product-info__price--compare">' + formatMoney(product.compare_at_price) + '</span>';
      }
      priceHtml += '<span class="product-info__price--current">' + formatMoney(product.price) + '</span>';

      // Size Guide link — uses product-info__size-guide class (same SVG as product page)
      var sizeGuideSvg = '<svg width="18" height="12" viewBox="0 0 24 14" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="1" y="1" width="22" height="12" rx="1"/><line x1="6" y1="1" x2="6" y2="6"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="6"/><line x1="18" y1="1" x2="18" y2="4"/></svg>';

      // Build color section — display only
      var colorSection = colorDisplay;

      // Build size section — matches product page fieldset structure
      var sizeSection = '';
      if (sizesHtml) {
        sizeSection =
          '<fieldset class="product-info__option product-info__option--size">' +
            '<div class="product-info__option-header">' +
              '<legend class="product-info__option-label">Size: <span data-qv-size-label>Select</span></legend>' +
              '<button type="button" class="product-info__size-guide" data-qv-size-guide>' +
                sizeGuideSvg + '<span>Size guide</span>' +
              '</button>' +
            '</div>' +
            '<div class="product-info__option-values product-info__option-values--circle">' + sizesHtml + '</div>' +
          '</fieldset>';
      } else {
        sizeSection =
          '<fieldset class="product-info__option">' +
            '<div class="product-info__option-header">' +
              '<button type="button" class="product-info__size-guide" data-qv-size-guide>' +
                sizeGuideSvg + '<span>Size guide</span>' +
              '</button>' +
            '</div>' +
          '</fieldset>';
      }

      // Quantity selector — same markup as Single Product Page
      var quantityHtml =
        '<div class="product-info__quantity">' +
          '<button type="button" class="product-info__qty-btn" data-qv-qty-minus aria-label="Decrease quantity">' +
            '<svg width="10" height="2" viewBox="0 0 10 2"><path d="M10 0v2H0V0z" fill="currentColor"/></svg>' +
          '</button>' +
          '<input type="number" value="1" min="1" class="product-info__qty-input" data-qv-qty-input aria-label="Quantity">' +
          '<button type="button" class="product-info__qty-btn" data-qv-qty-plus aria-label="Increase quantity">' +
            '<svg width="10" height="10" viewBox="0 0 10 10"><path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"/></svg>' +
          '</button>' +
        '</div>';

      // Buy row — quantity + ATC/Buy Now (same layout as Single Product Page)
      var buyRow =
        '<div class="product-info__buy-row">' +
          quantityHtml +
          '<div class="product-info__atc-col">' +
            '<button type="button" class="product-info__atc" data-qv-atc disabled>Add to cart</button>' +
            '<button type="button" class="product-info__buy-now" data-qv-buy-now disabled>Buy Now</button>' +
          '</div>' +
        '</div>';

      body.innerHTML =
        '<div class="qv-inner">' +
          '<div class="qv-inner__media">' +
            '<div class="qv-inner__main-image" data-qv-main-image><img src="' + mainImg + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '"></div>' +
            '<div class="qv-inner__thumbs-row">' +
              (showArrows ? '<button type="button" class="qv-inner__thumb-arrow qv-inner__thumb-arrow--prev" data-qv-thumb-prev aria-label="Previous"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="15 18 9 12 15 6"/></svg></button>' : '') +
              '<div class="qv-inner__thumbs" data-qv-thumbs>' + thumbsHtml + '</div>' +
              (showArrows ? '<button type="button" class="qv-inner__thumb-arrow qv-inner__thumb-arrow--next" data-qv-thumb-next aria-label="Next"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="9 18 15 12 9 6"/></svg></button>' : '') +
            '</div>' +
          '</div>' +
          '<div class="qv-inner__info">' +
            '<h2 class="product-info__title">' + (product.title || '') + '</h2>' +
            '<div class="product-info__price" data-qv-price>' + priceHtml + '</div>' +
            colorSection +
            sizeSection +
            buyRow +
            '<div class="qv-inner__view-full"><a href="/products/' + product.handle + '">View full details</a></div>' +
          '</div>' +
        '</div>';

      /* --- Thumbnail slider --- */
      var mainImageEl = body.querySelector('[data-qv-main-image] img');
      var thumbElements = body.querySelectorAll('[data-qv-thumb]');
      var currentThumb = 0;

      function selectThumb(idx) {
        if (idx < 0 || idx >= images.length) return;
        currentThumb = idx;
        thumbElements.forEach(function (t) { t.classList.remove('is-active'); });
        if (thumbElements[idx]) {
          thumbElements[idx].classList.add('is-active');
          if (mainImageEl) mainImageEl.src = getImageUrl(images[idx], '500x');
          thumbElements[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      thumbElements.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = parseInt(thumb.getAttribute('data-qv-thumb'), 10);
          selectThumb(idx);
        });
      });

      if (showArrows) {
        var prevBtn = body.querySelector('[data-qv-thumb-prev]');
        var nextBtn = body.querySelector('[data-qv-thumb-next]');
        if (prevBtn) prevBtn.addEventListener('click', function () {
          selectThumb(Math.max(0, currentThumb - 1));
        });
        if (nextBtn) nextBtn.addEventListener('click', function () {
          selectThumb(Math.min(images.length - 1, currentThumb + 1));
        });
      }

      /* --- Variant selection logic --- */
      var selected = {};
      var numOptions = (product.options || []).length;
      for (var i = 0; i < numOptions; i++) selected[i] = null;

      // Auto-select the color (display only, not customer-selectable)
      if (colorOptionIndex !== -1 && autoColor !== null) {
        selected[colorOptionIndex] = autoColor;
      }

      function findVariant() {
        // Only require size to be selected (color is auto-selected)
        if (sizeOptionIndex !== -1 && selected[sizeOptionIndex] === null) return null;
        // If no size option, check all options are set
        if (sizeOptionIndex === -1) {
          for (var i = 0; i < numOptions; i++) {
            if (selected[i] === null) return null;
          }
        }
        return (product.variants || []).find(function (v) {
          return v.options.every(function (opt, i) {
            // Only match against options that are selected
            return selected[i] === null || opt === selected[i];
          });
        });
      }

      function updateButtonsState() {
        // Update size button disabled state based on auto-selected color
        if (colorOptionIndex !== -1 && autoColor !== null && sizeOptionIndex !== -1) {
          body.querySelectorAll('[data-qv-size]').forEach(function (input) {
            var sizeVal = input.getAttribute('data-qv-size');
            var hasAvail = (product.variants || []).some(function (v) {
              return v.options[colorOptionIndex] === autoColor &&
                     v.options[sizeOptionIndex] === sizeVal && v.available;
            });
            var label = input.nextElementSibling;
            input.disabled = !hasAvail;
            if (label) label.classList.toggle('is-disabled', !hasAvail);
          });
        }
      }

      function updateVariant() {
        var match = findVariant();
        var atcBtn = body.querySelector('[data-qv-atc]');
        var buyNowBtn = body.querySelector('[data-qv-buy-now]');
        if (match && match.available) {
          atcBtn.disabled = false;
          buyNowBtn.disabled = false;
          atcBtn.setAttribute('data-qv-variant-id', match.id);
          buyNowBtn.setAttribute('data-qv-variant-id', match.id);
          var priceEl = body.querySelector('[data-qv-price]');
          if (priceEl) {
            var newPrice = '';
            if (match.compare_at_price > match.price) {
              newPrice = '<span class="product-info__price--compare">' + formatMoney(match.compare_at_price) + '</span>';
            }
            newPrice += '<span class="product-info__price--current">' + formatMoney(match.price) + '</span>';
            priceEl.innerHTML = newPrice;
          }
          if (match.featured_image) {
            var featuredImg = match.featured_image;
            if (typeof featuredImg === 'object' && featuredImg.src) featuredImg = featuredImg.src;
            if (typeof featuredImg === 'string') {
              var imgIdx = -1;
              images.forEach(function (img, i) {
                if (img && img.indexOf(featuredImg) !== -1) imgIdx = i;
              });
              if (imgIdx === -1) {
                images.forEach(function (img, i) {
                  if (img && featuredImg.indexOf(img.split('?')[0]) !== -1) imgIdx = i;
                });
              }
              if (imgIdx >= 0) selectThumb(imgIdx);
            }
          }
        } else {
          atcBtn.disabled = true;
          buyNowBtn.disabled = true;
          atcBtn.removeAttribute('data-qv-variant-id');
          buyNowBtn.removeAttribute('data-qv-variant-id');
        }
      }

      // Size selection — only selectable option
      body.querySelectorAll('[data-qv-size]').forEach(function (input) {
        input.addEventListener('change', function () {
          var sizeVal = input.getAttribute('data-qv-size');
          if (sizeOptionIndex !== -1) {
            selected[sizeOptionIndex] = sizeVal;
          } else {
            var vid = parseInt(sizeVal, 10);
            var variant = (product.variants || []).find(function (v) { return v.id === vid; });
            if (variant) {
              variant.options.forEach(function (opt, i) { selected[i] = opt; });
            }
          }
          var labelEl = body.querySelector('[data-qv-size-label]');
          if (labelEl) labelEl.textContent = sizeVal;
          updateButtonsState();
          updateVariant();
        });
      });

      // Auto-select if single variant (no size selection needed)
      if (product.variants && product.variants.length === 1 && product.variants[0].available) {
        var single = product.variants[0];
        single.options.forEach(function (opt, i) { selected[i] = opt; });
        if (sizeOptionIndex !== -1) {
          var sizeInput = body.querySelector('[data-qv-size="' + single.options[sizeOptionIndex].replace(/"/g, '&quot;') + '"]');
          if (sizeInput) { sizeInput.checked = true; }
          var szLbl = body.querySelector('[data-qv-size-label]');
          if (szLbl) szLbl.textContent = single.options[sizeOptionIndex];
        }
        updateVariant();
      }

      // If no size option but has variants, auto-select first available
      if (sizeOptionIndex === -1 && product.variants && product.variants.length > 0) {
        var firstAvail = (product.variants || []).find(function (v) { return v.available; });
        if (firstAvail) {
          firstAvail.options.forEach(function (opt, i) { selected[i] = opt; });
          updateVariant();
        }
      }

      // Auto-select size: first available size shown for the product
      if (sizeOptionIndex !== -1 && selected[sizeOptionIndex] === null) {
        var sizeInputs = body.querySelectorAll('[data-qv-size]');
        var firstAvailInput = null;
        sizeInputs.forEach(function (input) {
          if (!input.disabled && !firstAvailInput) firstAvailInput = input;
        });
        if (firstAvailInput) {
          firstAvailInput.checked = true;
          var autoSizeVal = firstAvailInput.getAttribute('data-qv-size');
          selected[sizeOptionIndex] = autoSizeVal;
          var autoLbl = body.querySelector('[data-qv-size-label]');
          if (autoLbl) autoLbl.textContent = autoSizeVal;
          updateVariant();
        }
      }

      // Quantity +/- controls (same behavior as Single Product Page)
      var qtyInput = body.querySelector('[data-qv-qty-input]');
      var qtyMinus = body.querySelector('[data-qv-qty-minus]');
      var qtyPlus = body.querySelector('[data-qv-qty-plus]');
      if (qtyMinus) qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      if (qtyPlus) qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });

      // ATC — uses selected quantity
      body.querySelector('[data-qv-atc]').addEventListener('click', function () {
        var vid = this.getAttribute('data-qv-variant-id');
        if (!vid) return;
        var qty = parseInt(qtyInput.value, 10) || 1;
        var formData = new FormData();
        formData.append('id', vid);
        formData.append('quantity', qty);
        if (window.WBCCart) {
          window.WBCCart.add(formData, function () { close(); });
        }
      });

      // Buy Now — direct to checkout, no delay
      body.querySelector('[data-qv-buy-now]').addEventListener('click', function () {
        var vid = this.getAttribute('data-qv-variant-id');
        if (!vid) return;
        var qty = parseInt(qtyInput.value, 10) || 1;
        this.disabled = true;
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty })
        })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            this.disabled = false;
          }.bind(this));
      });

      // Size Guide — open inline modal (fetch from product page)
      var sizeGuideBtn = body.querySelector('[data-qv-size-guide]');
      var sgModal = document.querySelector('[data-qv-size-guide-modal]');
      var sgBody = document.querySelector('[data-qv-size-guide-body]');
      if (sizeGuideBtn && sgModal) {
        sizeGuideBtn.addEventListener('click', function (e) {
          e.preventDefault();
          // Fetch the product page and extract the size guide modal content
          fetch('/products/' + product.handle)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var sourceModal = doc.querySelector('.size-guide-modal__body');
              if (sourceModal && sgBody) {
                sgBody.innerHTML = sourceModal.innerHTML;
                // Re-bind tab functionality
                var tabs = sgBody.querySelectorAll('[data-size-guide-tab]');
                tabs.forEach(function (tab) {
                  tab.addEventListener('click', function () {
                    var target = tab.getAttribute('data-size-guide-tab');
                    tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
                    sgBody.querySelectorAll('[data-size-guide-panel]').forEach(function (panel) {
                      panel.classList.toggle('is-active', panel.getAttribute('data-size-guide-panel') === target);
                    });
                  });
                });
              } else if (sgBody) {
                sgBody.innerHTML = '<p style="color:#888;font-size:14px;">Size guide not available for this product.</p>';
              }
            })
            .catch(function () {
              if (sgBody) sgBody.innerHTML = '<p style="color:#888;font-size:14px;">Error loading size guide.</p>';
            });
          sgModal.classList.add('is-open');
        });
        // Close handlers
        sgModal.querySelectorAll('[data-qv-size-guide-close]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            sgModal.classList.remove('is-open');
          });
        });
      }
    }

    // Use event delegation for Quick View buttons (works even with dynamically loaded products)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      open(handle);
    });

    modal.querySelectorAll('[data-qv-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    // Expose Quick View open function so Quick Add can use it
    window.WBCQuickView = { open: open };
  }

  function initQuickAdd() {
    var popup = document.querySelector('[data-quick-add-popup]');
    if (!popup) return;
    var sizesContainer = popup.querySelector('[data-qa-sizes]');
    var selectedSizeEl = popup.querySelector('[data-qa-selected-size]');
    var addBtn = popup.querySelector('[data-qa-add]');
    var imageEl = popup.querySelector('[data-qa-image]');
    var titleEl = popup.querySelector('[data-qa-title]');
    var priceEl = popup.querySelector('[data-qa-price]');
    var productCache = {};
    var currentProduct = null;
    var selectedVariantId = null;

    function fetchProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          productCache[handle] = product;
          return product;
        });
    }

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function getImageUrl(src, size) {
      if (!src) return '';
      return src.replace(/\.(jpg|jpeg|png|gif|webp)/i, function (match) {
        return '_' + size + match;
      });
    }

    function open(handle) {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      sizesContainer.innerHTML = '<div style="font-size:13px;color:#888;">Loading...</div>';
      selectedSizeEl.textContent = 'Select a size';
      addBtn.disabled = true;
      selectedVariantId = null;
      // Clear product info while loading
      imageEl.innerHTML = '';
      titleEl.textContent = '';
      priceEl.innerHTML = '';
      currentProduct = null;

      fetchProduct(handle).then(function (product) {
        currentProduct = product;
        // Populate product image, title, price
        if (imageEl && product.images && product.images[0]) {
          imageEl.innerHTML = '<img src="' + getImageUrl(product.images[0], '200x') + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '">';
        }
        if (titleEl) titleEl.textContent = product.title || '';
        if (priceEl) {
          var priceHtml = '';
          if (product.compare_at_price > product.price) {
            priceHtml = '<span class="qa-popup__price--compare">' + formatMoney(product.compare_at_price) + '</span>';
          }
          priceHtml += formatMoney(product.price);
          priceEl.innerHTML = priceHtml;
        }
        renderSizes(product);
      }).catch(function () {
        sizesContainer.innerHTML = '<div style="font-size:13px;color:#888;">Error loading product. Please try again.</div>';
      });
    }

    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function renderSizes(product) {
      // Find the "Size" option if it exists
      var sizeOptionIndex = -1;
      product.options.forEach(function (opt, i) {
        if (opt === 'Size' || opt === 'size') sizeOptionIndex = i;
      });

      // If no Size option, check if product has only one variant (no options needed)
      if (sizeOptionIndex === -1) {
        // No size option — if single variant, add directly
        if (product.variants.length === 1 && product.variants[0].available) {
          selectedVariantId = product.variants[0].id;
          selectedSizeEl.textContent = 'One size';
          addBtn.disabled = false;
          sizesContainer.innerHTML = '<div style="font-size:13px;color:#888;">This product has a single variant.</div>';
        } else {
          // Multiple options but no Size — show all as "Default"
          sizesContainer.innerHTML = '';
          product.variants.forEach(function (v) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'qa-popup__size' + (v.available ? '' : ' is-disabled');
            btn.textContent = v.title;
            if (!v.available) btn.disabled = true;
            btn.addEventListener('click', function () {
              selectVariant(v);
            });
            sizesContainer.appendChild(btn);
          });
        }
        return;
      }

      // Get unique size values
      var sizeValues = [];
      product.variants.forEach(function (v) {
        var val = v.options[sizeOptionIndex];
        if (sizeValues.indexOf(val) === -1) sizeValues.push(val);
      });

      sizesContainer.innerHTML = '';
      sizeValues.forEach(function (size) {
        // Find first available variant with this size
        var variant = product.variants.find(function (v) {
          return v.options[sizeOptionIndex] === size && v.available;
        });
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qa-popup__size' + (variant ? '' : ' is-disabled');
        btn.textContent = size;
        if (!variant) btn.disabled = true;
        btn.addEventListener('click', function () {
          if (variant) selectVariant(variant, size);
        });
        sizesContainer.appendChild(btn);
      });
    }

    function selectVariant(variant, sizeLabel) {
      selectedVariantId = variant.id;
      selectedSizeEl.textContent = sizeLabel || variant.title;
      addBtn.disabled = false;
      // Update selected state
      sizesContainer.querySelectorAll('.qa-popup__size').forEach(function (b) { b.classList.remove('is-selected'); });
      if (sizeLabel) {
        sizesContainer.querySelectorAll('.qa-popup__size').forEach(function (b) {
          if (b.textContent === sizeLabel) b.classList.add('is-selected');
        });
      }
    }

    // Event delegation for Quick Add buttons — toggles INLINE size selector in the product card
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      // Find the inline add container in the same product card
      var card = btn.closest('.ccard');
      if (!card) return;
      var inlineAdd = card.querySelector('[data-ccard-inline-add]');
      if (!inlineAdd) return;
      // Toggle: if already open, close it
      if (inlineAdd.classList.contains('is-open')) {
        inlineAdd.classList.remove('is-open');
        inlineAdd.setAttribute('aria-hidden', 'true');
        return;
      }
      // Close any other open inline selectors
      document.querySelectorAll('.ccard__inline-add.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
      });
      // Open this one
      inlineAdd.classList.add('is-open');
      inlineAdd.setAttribute('aria-hidden', 'false');
      // Load sizes if not already loaded — check both desktop and mobile containers
      var desktopContainer = inlineAdd.querySelector('[data-inline-sizes-desktop]');
      var mobileContainer = inlineAdd.querySelector('[data-inline-sizes]');
      var needsLoad = (desktopContainer && !desktopContainer.hasChildNodes()) ||
                      (mobileContainer && !mobileContainer.hasChildNodes());
      if (needsLoad) {
        if (desktopContainer) desktopContainer.innerHTML = '<div style="font-size:12px;color:#888;">Loading...</div>';
        if (mobileContainer) mobileContainer.innerHTML = '<div style="font-size:12px;color:#888;">Loading...</div>';
        fetchProduct(handle).then(function (product) {
          renderInlineSizes(product, inlineAdd);
        }).catch(function () {
          if (desktopContainer) desktopContainer.innerHTML = '<div style="font-size:12px;color:#888;">Error loading sizes.</div>';
          if (mobileContainer) mobileContainer.innerHTML = '<div style="font-size:12px;color:#888;">Error loading sizes.</div>';
        });
      }
    });

    // Inline size rendering + selection + add to cart (handles both desktop and mobile panels)
    function renderInlineSizes(product, inlineAdd) {
      // Desktop elements
      var desktopSizesContainer = inlineAdd.querySelector('[data-inline-sizes-desktop]');
      var desktopSelectedSizeEl = inlineAdd.querySelector('[data-inline-selected-size-desktop]');
      var desktopAddBtn = inlineAdd.querySelector('[data-inline-add-btn-desktop]');
      // Mobile elements
      var mobileSizesContainer = inlineAdd.querySelector('[data-inline-sizes]');
      var mobileSelectedSizeEl = inlineAdd.querySelector('[data-inline-selected-size]');
      var mobileAddBtn = inlineAdd.querySelector('[data-inline-add-btn]');
      var mobileTitleEl = inlineAdd.querySelector('[data-inline-title]');
      var mobilePriceEl = inlineAdd.querySelector('[data-inline-price]');
      var mobileColorSection = inlineAdd.querySelector('[data-inline-color-section]');
      var mobileColorLabel = inlineAdd.querySelector('[data-inline-color-label]');
      var mobileColorsContainer = inlineAdd.querySelector('[data-inline-colors]');
      var mobileQtyInput = inlineAdd.querySelector('[data-inline-qty-input]');
      var mobileQtyMinus = inlineAdd.querySelector('[data-inline-qty-minus]');
      var mobileQtyPlus = inlineAdd.querySelector('[data-inline-qty-plus]');

      var selectedVariantId = null;
      var selectedQty = 1;

      // Find the "Size" option
      var sizeOptionIndex = -1;
      (product.options || []).forEach(function (opt, i) {
        var optStr = typeof opt === 'string' ? opt : String(opt || '');
        if (optStr.toLowerCase() === 'size') sizeOptionIndex = i;
      });

      // Find the "Color" option
      var colorOptionIndex = -1;
      (product.options || []).forEach(function (opt, i) {
        var optStr = typeof opt === 'string' ? opt : String(opt || '');
        if (optStr.toLowerCase() === 'color' || optStr.toLowerCase() === 'colour') colorOptionIndex = i;
      });

      // --- Populate mobile product info ---
      if (mobileTitleEl) mobileTitleEl.textContent = product.title || '';
      if (mobilePriceEl) {
        var priceHtml = '';
        if (product.compare_at_price > product.price) {
          priceHtml = '<span class="product-info__price--compare">' + formatMoney(product.compare_at_price) + '</span>';
        }
        priceHtml += '<span class="product-info__price--current">' + formatMoney(product.price) + '</span>';
        mobilePriceEl.innerHTML = priceHtml;
      }

      // --- Populate mobile color section (matches Single Product Page) ---
      if (colorOptionIndex !== -1 && mobileColorSection && mobileColorsContainer) {
        var colorValues = [];
        (product.variants || []).forEach(function (v) {
          var val = v.options[colorOptionIndex];
          if (colorValues.indexOf(val) === -1) colorValues.push(val);
        });
        if (colorValues.length > 0) {
          mobileColorSection.style.display = '';
          if (mobileColorLabel) mobileColorLabel.textContent = colorValues[0];
          mobileColorsContainer.innerHTML = '';
          colorValues.forEach(function (color, idx) {
            var colorStr = typeof color === 'string' ? color : String(color || '');
            var colorHandle = colorStr.toLowerCase().replace(/ /g, '-');
            var hex = (window.WBCColorMap && window.WBCColorMap[colorHandle]) ? window.WBCColorMap[colorHandle] : '#ccc';
            // Use input + label structure (same as Single Product Page) so CSS works
            var input = document.createElement('input');
            input.type = 'radio';
            input.name = 'inline-color-' + (product.id || '');
            input.value = colorStr;
            input.id = 'inline-color-' + (product.id || '') + '-' + idx;
            input.className = 'sr-only';
            if (idx === 0) input.checked = true;
            input.addEventListener('change', function () {
              if (mobileColorLabel) mobileColorLabel.textContent = colorStr;
              // Re-find variant with selected color + size
              reselectVariant();
            });
            var label = document.createElement('label');
            label.htmlFor = input.id;
            label.className = 'product-info__swatch';
            label.style.setProperty('--hdt-bg-color', hex);
            label.title = colorStr;
            var labelSpan = document.createElement('span');
            labelSpan.className = 'sr-only';
            labelSpan.textContent = colorStr;
            label.appendChild(labelSpan);
            mobileColorsContainer.appendChild(input);
            mobileColorsContainer.appendChild(label);
          });
        }
      }

      // --- Quantity controls (mobile) ---
      if (mobileQtyMinus) {
        mobileQtyMinus.addEventListener('click', function () {
          var v = parseInt(mobileQtyInput.value, 10) || 1;
          if (v > 1) mobileQtyInput.value = v - 1;
          selectedQty = parseInt(mobileQtyInput.value, 10) || 1;
        });
      }
      if (mobileQtyPlus) {
        mobileQtyPlus.addEventListener('click', function () {
          var v = parseInt(mobileQtyInput.value, 10) || 1;
          if (v < 99) mobileQtyInput.value = v + 1;
          selectedQty = parseInt(mobileQtyInput.value, 10) || 1;
        });
      }
      if (mobileQtyInput) {
        mobileQtyInput.addEventListener('change', function () {
          selectedQty = parseInt(mobileQtyInput.value, 10) || 1;
        });
      }

      // --- Helper: re-select variant when color changes (mobile) ---
      function reselectVariant() {
        // Get selected color
        var selectedColor = null;
        if (mobileColorsContainer) {
          var checkedInput = mobileColorsContainer.querySelector('input:checked');
          if (checkedInput) selectedColor = checkedInput.value;
        }
        // Get selected size from the label
        var selectedSize = mobileSelectedSizeEl ? mobileSelectedSizeEl.textContent : null;
        // Find matching variant
        var match = null;
        if (sizeOptionIndex !== -1 && colorOptionIndex !== -1 && selectedColor && selectedSize) {
          match = product.variants.find(function (v) {
            return v.options[colorOptionIndex] === selectedColor &&
                   v.options[sizeOptionIndex] === selectedSize && v.available;
          });
        } else if (colorOptionIndex !== -1 && selectedColor) {
          match = product.variants.find(function (v) {
            return v.options[colorOptionIndex] === selectedColor && v.available;
          });
        }
        if (match) {
          selectedVariantId = match.id;
          if (mobileAddBtn) mobileAddBtn.disabled = false;
        }
      }

      // --- Helper: create a size button ---
      function createSizeButton(size, variant, container, sizeClass, onSelect) {
        var sizeBtn = document.createElement('button');
        sizeBtn.type = 'button';
        sizeBtn.className = sizeClass + (variant ? '' : ' is-disabled');
        sizeBtn.textContent = size;
        if (!variant) sizeBtn.disabled = true;
        sizeBtn.addEventListener('click', function () {
          if (variant) {
            onSelect(variant, size, sizeBtn, container);
          }
        });
        container.appendChild(sizeBtn);
        return sizeBtn;
      }

      // --- Helper: create a variant button (no size option) ---
      function createVariantButton(v, container, sizeClass, onSelect) {
        var sizeBtn = document.createElement('button');
        sizeBtn.type = 'button';
        sizeBtn.className = sizeClass + (v.available ? '' : ' is-disabled');
        var sizeLabel = v.title || '';
        if (sizeLabel.indexOf(' / ') !== -1) sizeLabel = sizeLabel.split(' / ').pop();
        sizeBtn.textContent = sizeLabel;
        if (!v.available) sizeBtn.disabled = true;
        sizeBtn.addEventListener('click', function () {
          onSelect(v, sizeLabel, sizeBtn, container);
        });
        container.appendChild(sizeBtn);
        return sizeBtn;
      }

      // --- Desktop selection handler ---
      function desktopOnSelect(variant, size, btn, container) {
        selectedVariantId = variant.id;
        if (desktopSelectedSizeEl) desktopSelectedSizeEl.textContent = size;
        if (desktopAddBtn) desktopAddBtn.disabled = false;
        container.querySelectorAll('.ccard__inline-size').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
      }

      // --- Mobile selection handler ---
      function mobileOnSelect(variant, size, btn, container) {
        selectedVariantId = variant.id;
        if (mobileSelectedSizeEl) mobileSelectedSizeEl.textContent = size;
        if (mobileAddBtn) mobileAddBtn.disabled = false;
        container.querySelectorAll('.product-info__size-pill, .ccard__inline-size').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
      }

      // --- Render sizes for both desktop and mobile ---
      if (sizeOptionIndex === -1) {
        // No size option
        if (product.variants.length === 1 && product.variants[0].available) {
          selectedVariantId = product.variants[0].id;
          if (desktopSelectedSizeEl) desktopSelectedSizeEl.textContent = 'One size';
          if (mobileSelectedSizeEl) mobileSelectedSizeEl.textContent = 'One size';
          if (desktopAddBtn) desktopAddBtn.disabled = false;
          if (mobileAddBtn) mobileAddBtn.disabled = false;
          if (desktopSizesContainer) desktopSizesContainer.innerHTML = '<div style="font-size:12px;color:#888;">Single variant</div>';
          if (mobileSizesContainer) mobileSizesContainer.innerHTML = '<div style="font-size:12px;color:#888;">Single variant</div>';
        } else {
          // Multiple variants, no Size option — show variant titles (size part only)
          if (desktopSizesContainer) desktopSizesContainer.innerHTML = '';
          if (mobileSizesContainer) mobileSizesContainer.innerHTML = '';
          var firstAvailDesktop = null;
          var firstAvailMobile = null;
          product.variants.forEach(function (v) {
            if (desktopSizesContainer) {
              var dBtn = createVariantButton(v, desktopSizesContainer, 'ccard__inline-size', desktopOnSelect);
              if (v.available && !firstAvailDesktop) firstAvailDesktop = dBtn;
            }
            if (mobileSizesContainer) {
              var mBtn = createVariantButton(v, mobileSizesContainer, 'product-info__size-pill', mobileOnSelect);
              if (v.available && !firstAvailMobile) firstAvailMobile = mBtn;
            }
          });
          // Auto-select first available
          if (firstAvailDesktop) firstAvailDesktop.click();
          if (firstAvailMobile && firstAvailMobile !== firstAvailDesktop) firstAvailMobile.click();
        }
      } else {
        // Has Size option — get unique size values
        var sizeValues = [];
        product.variants.forEach(function (v) {
          var val = v.options[sizeOptionIndex];
          if (sizeValues.indexOf(val) === -1) sizeValues.push(val);
        });

        if (desktopSizesContainer) desktopSizesContainer.innerHTML = '';
        if (mobileSizesContainer) mobileSizesContainer.innerHTML = '';
        var firstAvailDesktopBtn = null;
        var firstAvailMobileBtn = null;

        sizeValues.forEach(function (size) {
          var variant = product.variants.find(function (v) {
            return v.options[sizeOptionIndex] === size && v.available;
          });
          if (desktopSizesContainer) {
            var dBtn = createSizeButton(size, variant, desktopSizesContainer, 'ccard__inline-size', desktopOnSelect);
            if (variant && !firstAvailDesktopBtn) firstAvailDesktopBtn = dBtn;
          }
          if (mobileSizesContainer) {
            var mBtn = createSizeButton(size, variant, mobileSizesContainer, 'product-info__size-pill', mobileOnSelect);
            if (variant && !firstAvailMobileBtn) firstAvailMobileBtn = mBtn;
          }
        });

        // Auto-select first available size
        if (firstAvailDesktopBtn) firstAvailDesktopBtn.click();
        if (firstAvailMobileBtn) firstAvailMobileBtn.click();
      }

      // --- Setup ADD buttons for both desktop and mobile ---
      if (desktopAddBtn) {
        setupInlineAddBtn(desktopAddBtn, inlineAdd, function () { return selectedVariantId; }, function () { return 1; });
      }
      if (mobileAddBtn) {
        setupInlineAddBtn(mobileAddBtn, inlineAdd, function () { return selectedVariantId; }, function () { return selectedQty; });
      }
    }

    function setupInlineAddBtn(addBtnEl, inlineAdd, getVariantId, getQty) {
      // Remove any previous listener by cloning
      var newBtn = addBtnEl.cloneNode(true);
      addBtnEl.parentNode.replaceChild(newBtn, addBtnEl);
      var originalText = newBtn.textContent;
      newBtn.addEventListener('click', function () {
        var vid = getVariantId();
        if (!vid) return;
        var qty = getQty ? getQty() : 1;
        var formData = new FormData();
        formData.append('id', vid);
        formData.append('quantity', qty);
        newBtn.disabled = true;
        newBtn.textContent = 'Adding...';
        if (window.WBCCart) {
          window.WBCCart.add(formData, function () {
            // Close inline selector on success
            inlineAdd.classList.remove('is-open');
            inlineAdd.setAttribute('aria-hidden', 'true');
            newBtn.disabled = false;
            newBtn.textContent = originalText;
          }, function () {
            newBtn.disabled = false;
            newBtn.textContent = originalText;
          });
        }
      });
    }

    // Close inline selector when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.ccard__inline-add') && !e.target.closest('[data-quick-add]')) {
        document.querySelectorAll('.ccard__inline-add.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          el.setAttribute('aria-hidden', 'true');
        });
      }
    });

    // Close inline selector via X button (mobile)
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-inline-close]');
      if (!closeBtn) return;
      e.preventDefault();
      e.stopPropagation();
      var inlineAdd = closeBtn.closest('.ccard__inline-add');
      if (inlineAdd) {
        inlineAdd.classList.remove('is-open');
        inlineAdd.setAttribute('aria-hidden', 'true');
      }
    });

    popup.querySelectorAll('[data-qa-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    addBtn.addEventListener('click', function () {
      if (!selectedVariantId) return;
      var formData = new FormData();
      formData.append('id', selectedVariantId);
      formData.append('quantity', 1);
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      if (window.WBCCart) {
        window.WBCCart.add(formData, function () {
          close();
          addBtn.textContent = 'ADD';
        }, function () {
          addBtn.disabled = false;
          addBtn.textContent = 'ADD';
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });
  }

  function init() {
    initHeaderScroll();
    initDrawer();
    initSubmenuToggle();
    initAccordions();
    initReadMore();
    initAboutToggle();
    initSwatches();
    initReadMoreResizeCheck();
    initFeaturesCarousel();
    initProductsCarousel();
    initCartDrawer();
    initDoubleTapZoomLock();
    loadComingSoonVariants();
    initBuyNow();
    initQuickView();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
